import { NgError } from './ng-error';
import { StatusTypes } from './status-types';

export class NgResponse<TResponse> {
  errors: Array<NgError>;
  status: StatusTypes;
  response: TResponse;

  get error(): NgError {
    return this.errors?.length > 0 ? this.errors[0] : null;
  }

  set error(value: NgError) {
    this.errors = value ? [ value ] : [];
  }

  constructor(init?: Partial<NgResponse<TResponse>>) {
    Object.assign(this, init);
  }

  static error<TResponse>(errors: NgError | Array<NgError>): NgResponse<TResponse> {
    return new NgResponse<TResponse>({
      errors: Array.isArray(errors) ? errors : [ errors ],
      status: StatusTypes.Success
    });
  }

  static create<TResponse>(response: TResponse): NgResponse<TResponse> {
    return new NgResponse<TResponse>({
      response: response,
      status: StatusTypes.Success
    });
  }
}